import { CPS_CONTENT_TYPE_FIELD_TYPE, type CpsContentTypeFieldType } from '@cs-cms/types';
import type { FieldChangeHandler, FieldChangeHandlers } from './fieldInteractionsTypes';

const DEFAULT_HANDLER_KEY = 'onUndefinedFieldChange';

const fieldTypeToHandlerKey: Partial<Record<CpsContentTypeFieldType, keyof FieldChangeHandlers>> = {
  [CPS_CONTENT_TYPE_FIELD_TYPE.UNDEFINED]: DEFAULT_HANDLER_KEY,
  [CPS_CONTENT_TYPE_FIELD_TYPE.CONTENT_TYPE]: DEFAULT_HANDLER_KEY,
  [CPS_CONTENT_TYPE_FIELD_TYPE.CONTENT_TYPE_VERSION]: DEFAULT_HANDLER_KEY,
  [CPS_CONTENT_TYPE_FIELD_TYPE.STRING]: 'onStringNumberFieldChange',
  [CPS_CONTENT_TYPE_FIELD_TYPE.INT]: 'onStringNumberFieldChange',
  [CPS_CONTENT_TYPE_FIELD_TYPE.INT64]: 'onStringNumberFieldChange',
  [CPS_CONTENT_TYPE_FIELD_TYPE.DECIMAL]: 'onStringNumberFieldChange',
  [CPS_CONTENT_TYPE_FIELD_TYPE.DATE]: 'onDateFieldChange',
  [CPS_CONTENT_TYPE_FIELD_TYPE.DATETIME]: 'onDateFieldChange',
  [CPS_CONTENT_TYPE_FIELD_TYPE.BOOL]: 'onBoolFieldChange',
  [CPS_CONTENT_TYPE_FIELD_TYPE.CHOICE]: 'onChoiceSelectionChange',
  [CPS_CONTENT_TYPE_FIELD_TYPE.MULTI_CHOICE]: 'onChoiceSelectionChange'
};

export const resolveFieldChangeHandler = (
  fieldType: CpsContentTypeFieldType,
  handlers: FieldChangeHandlers
): FieldChangeHandler => {
  const handlerKey = fieldTypeToHandlerKey[fieldType] ?? DEFAULT_HANDLER_KEY;
  return handlers[handlerKey];
};
